<template>
   <intersect @enter="animate = true">
    <div class="reasonsSliderContainer container" :class="noBg">
      <div
        class="mainTtl noto-semibold fadeUp"
        :class="animate ? 'animate' : ''"
        v-if="_.get(itemData, 'conf.useHeader') == 1"
      >{{_.get(itemData, 'conf.header.title')}}</div>
      <div
        class="descr fadeUp"
        :class="animate ? 'animate' : ''"
        v-if="_.get(itemData, 'conf.useHeader') == 1"
      >{{_.get(itemData, 'conf.header.teaser')}}</div>
      <div class="reasonSliderOuter">
        <swiper class="reasonsSlider fadeUp"  ref="reasonsSlider" :options="swiperOptions" :class="animate ? 'animate' : ''">
          <swiper-slide v-for="(slide, index) in itemData.data" :key="index">
            <router-link :to="_.get(slide, 'smartbuttons.0') ? _.get(slide, 'smartbuttons.0.url') : $store.getters.getSingleUrl(slide, 1)" class="reasonSliderItem" >
              <div class="imgContainer">
                <picture >
                    <source media="(max-width: 767px)" :srcset="getCoverImg(slide).mobile">
                    <source media="(max-width: 1023px)" :srcset="getCoverImg(slide).tablet">
                    <img :srcset="getCoverImg(slide).desktop" class="img-absolute" alt="">
                </picture>
              </div>
              <div class="descrContainer">
                <div class="ttl">{{_.get(slide,'title')}}</div>

                <div class="reasonsSlBtn btn" :title="slide.id">{{$fn.tr('read more')}}</div>
<!--                <SmartButton :cssclass="'reasonsSlBtn btn'" :itemData="_.get(slide, 'smartbuttons.0')" />-->
              </div>
            </router-link>
          </swiper-slide>
        </swiper>
        <div v-if="(itemData.data.length > 1)" class="swiper-pagination"></div>
      </div>
    </div>
  </intersect>
</template>
<script>
  import SmartButton from "./modules/SmartButton";
  import Intersect from 'vue-intersect'
  export default {
    components: {
      SmartButton,
      Intersect
    },
    data() {
    return {
      animate: false,
      swiperOptions: {
        speed: 800,
        watchOverflow: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          320: {
            spaceBetween: 10,
            slidesPerView:  this.itemData.data.length > 1 ? 1.2 : 1,
          },
          768: {
            spaceBetween: 20,
            slidesPerView: 1.5,
          },
        },
      },
    };
  },
  props: ["itemData", "titleData", "noBg"],
    computed: {
      swiper() {
        return this.$refs.reasonsSlider.swiper;
      },
    },
    mounted() {
      if(this.$refs.reasonsSlider && this.$refs.reasonsSlider.swiper) this.$refs.reasonsSlider.swiper.init()
    },
    destroyed() {
      if(this.$refs.reasonsSlider && this.$refs.reasonsSlider.swiper) this.$refs.reasonsSlider.swiper.destroy()
    },
    methods: {
      getCoverImg(item){

        if(_.get(item, 'hover_image') && _.get(item, 'hover_image').length){
          return _.get(item, 'hover_image.0.devices')
        }
        if(_.get(item, 'cover_image') && _.get(item, 'cover_image').length){
          return _.get(item, 'cover_image.0.devices')
        }

        return _.get(item, 'images.0.devices')
      }
    }
  };
</script>

<style>
.reasonsSliderContainer.noBg:after {
  display: none;
}
</style>
